<!--教师列表-->
<template>
	<div class='lg-teacher lg-contain-background'>
		<div class="user-list">
			<div class="user-list-item" v-for="item in formData" :key="item.id" @click="handelOpenDetail('teacher_home',item.user_id)">
				<img :src="item.avatar_info" alt="">
				<div class="introduce">
					<p>{{item.nickname}}</p>
					<p>{{item.category_name}}</p>
					<p>{{item.intro}}</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
  export default {
    name: "index",
    props:['formData'],
    data() {
      return {
      }
    },
    methods: {
      handelOpenDetail(url,data){
        const {href} = this.$router.resolve({
          name: url,
          query: {
            id:data
          }
        })
        window.open(href, '_blank')
      },
    }
  }
</script>

<style scoped lang='less'>
	.lg-teacher{
		.user-list{
			display: flex;
			flex-wrap: wrap;
			.user-list-item{
				background-color: #FFFFFF;
				border-radius: 4px;
				width: 265px;
				min-height: 260px;
				padding: 20px 0;
				margin-bottom: 20px;
				margin-right: 28px;
				cursor: pointer;
				img{
					width: 112px;
					height: 112px;
					border-radius: 50%;
					margin: 0 auto 15px;
				}
				.introduce{
					p:first-child{
						color: #333333;
						font-size: 18px;
						font-weight: 600;
					}
					p:nth-child(2){
						color: #666666;
						font-size: 14px;
					}
					p:last-child{
						color: #8d92a1;
						font-size: 12px;
						padding: 0 18px;
						line-height: 21px;
						display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
						-webkit-box-orient: vertical; //设置或检索伸缩盒对象的子元素的排列方式
						-webkit-line-clamp: 3;  //一个块元素显示的文本的行数
						overflow: hidden; //溢出隐藏
					}
					p:not(:last-child){
						text-align: center;
						margin-bottom: 10px;
					}
				}
			}
			.user-list-item:nth-child(5n){
				margin-right: 0;
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/components/teacher/index.vue